
import SelectIcon from '~/assets/images/select-icons.svg?inline'
import WPopover from '../w-popover/w-popover'
import WOptionList from '../w-option-list/w-option-list'
import WButtonLook, { themeableProps } from '../w-button-look/w-button-look'

const { icon, variant, iconAligment, ...themeablePropsSubSet } = themeableProps

export default {
  components: { WPopover, WButtonLook, WOptionList },

  inject: {
    formControlIds: {
      default: () => ({}),
    },
    dialogId: {
      default: () => null,
    },
    formControlTriggerInput: {
      default: () => {
        return () => {}
      },
    },
  },
  inheritAttrs: false,

  props: {
    ...themeablePropsSubSet,

    name: {
      type: String,
      default: null,
    },

    value: {
      type: [String, Number, Array, Object],
      default: null,
    },

    options: {
      type: Array,
      default: () => [],
    },

    multiple: {
      type: Boolean,
      default: false,
    },

    action: {
      type: String,
      default: 'select',
    },

    isSearchable: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isPopupShown: false,
      searchText: '',
    }
  },

  computed: {
    filteredOptions() {
      if (!this.isSearchable) {
        return this.options
      }
      return this.options.filter((option) => {
        return option.label
          .toLowerCase()
          .includes(this.searchText.toLowerCase())
      })
    },
    themeablePropValues() {
      const entries = Object.keys(themeablePropsSubSet).map((key) => [
        key,
        this[key],
      ])
      return Object.fromEntries(entries)
    },
    selectedIds() {
      let ids
      const extractId = (item) => item.id ?? item
      if (Array.isArray(this.value)) {
        ids = new Set(this.value.map(extractId))
      } else {
        ids = new Set()
        if (this.value !== undefined && this.value !== null) {
          ids.add(extractId(this.value))
        }
      }
      return ids
    },
    selectedOptions() {
      return this.options.filter((option) => {
        return this.selectedIds.has(option.id)
      })
    },
    selectedLabel() {
      return this.selectedOptions.map((option) => option.label).join(', ')
    },
  },

  watch: {
    disabled(newValue) {
      if (newValue) {
        this.isPopupShown = false
      }
    },
  },

  created() {
    this.selectIcon = SelectIcon

    /* positioning strategy should be dependant on whether the select exists in a dialog */
    this.positioningStrategy = this.dialogId ? 'fixed' : 'absolute'
  },

  methods: {
    onClickOption(id) {
      let closePrevented = false

      this.$emit('close', {
        id,
        preventClose() {
          closePrevented = true
        },
      })

      if (!closePrevented) {
        this.hidePopup()
        this.$refs.button.$el.focus()
      }

      this.$nextTick(() => {
        this.formControlTriggerInput()
        this.syncPopupWidthWithReference()
      })
    },
    showPopup(e) {
      this.isPopupShown = true
      this.syncPopupWidthWithReference()
    },
    syncPopupWidthWithReference() {
      /* make sure that the popup is at least as width as the reference element (otherwise it looks weird) */
      if (this.$refs.options && this.$refs.button) {
        /* fix timing bug */
        this.$refs.options.$el.style.minWidth = `${this.$refs.button.$el.offsetWidth}px`
      }
    },
    hidePopup(e) {
      if (e instanceof KeyboardEvent) {
        this.$refs.button.$el.focus()
      }
      this.isPopupShown = false
    },
    onPopupShown() {
      this.$refs.options.$el.focus()
    },
  },
}
